import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appTags',
  getURL: 'appId/roommanualtags',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: true,
  sessionParams: ['appId'],
  emptyMessage: "You don’t have any tags yet. Go to the Tag Manager to create your first one.",
  emptyButtonUrl:"/tagmanager/new",
  emptyButton:"+ Create New Tag",
  createButton: "Create New Tag",
  createButtonUrl: "/tagmanager/new",
  fields: [
    {
      attributeName: 'typeTagAssignment',
      label: 'Assig.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:false,
      canEdit: false,
      canCreate: false,
      helpText: 'Asignment of the tag.',
      exactWidth:'10px'
    },
    {
      attributeName: 'typeTagName',
      label: 'Category',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Category of the tag.',
      exactWidth:'10px'
    },
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: false,
      canFilter:true,
      canEdit: false,
      canCreate: false,
      helpText: 'Name of the tag.',
    },
    {
      attributeName: 'videoPreview',
      label: 'Video Preview',
      type: FormInputTypes.TAGS_PREVIEW,
      helpText: 'Tag preview in video',
      
    },
    {
      attributeName: 'extendedInfoPreview',
      label: 'Ex. Info Preview',
      type: FormInputTypes.TAGS_PREVIEW,
      helpText: 'Tag preview in extended info',
      
    },
  ],
};
